import React, { FC } from 'react'

import { EmptyAvatar } from 'components/page/ForeignProfile/Photos/Photos.styled'
import { PhotosType } from 'components/page/ForeignProfile/Photos/PhotosTile/PhotosTile.types'
import { ListItemPhoto } from 'components/page/Search/Search.styled'
import { PHOTO_SIZES } from 'components/page/Search/searchPromoFunctions'
import { NoPhoto } from 'components/presentational/NoPhoto/NoPhoto'
import { GQLGender, GQLPhotoFaceCenter } from 'generated-graphql/graphql'

export const ItemImageLegacy: FC<{
  userId: number
  name: string
  gender: GQLGender
  imageSet?: Record<string, string>
  coordinates?: GQLPhotoFaceCenter
}> = ({ imageSet, name, gender, userId, coordinates }) => {
  if (imageSet) {
    return (
      <ListItemPhoto
        src={imageSet[PHOTO_SIZES.SQUARE.ID]}
        srcSet={Object.values(imageSet).join(', ')}
        data-name="user-photo"
        loading="lazy"
        alt={name}
        width={PHOTO_SIZES.SQUARE.SIZE}
        height={PHOTO_SIZES.SQUARE.SIZE}
        $type={PhotosType.square}
        $coordinates={coordinates}
      />
    )
  }

  return (
    <EmptyAvatar data-name={`empty-photo-${gender}-${userId}`}>
      <NoPhoto gender={gender} id={String(userId)} />
    </EmptyAvatar>
  )
}
